export default __webpack_public_path__ + "static/media/nerd_glasses.e2feab28.png";